import React, { useState } from "react";
import MainBanner from "../../../Components/MainBanner";
import AskSection from "../../../Components/AskSection";
import BenefitsSection from "../../../Components/BenefitsSection";
import HelpSteps from "../../../Components/HelpSteps";
import BonusSection from "../../../Components/BonusSection";
import StudentStories from "../../../Components/StudentStories";
import ChatHelpExperts from "../../../Components/ChatHelpExperts";
import AssignmentList from "../../../Components/AssignmentList";
import Universities from "../../../Components/Universities";
import Milestonerewards from "../../../Components/Milestonerewards";
import CommonForm from "../../HomePage/Form/CommonForm";
import ScrollTop from "../../../Components/Buttons/ScrollTop";
import Page from "../../Metadata/Page";
import ComWorldWide from "../../../Components/ComWorldWide";
import ComReadMoreSection from "../../../Components/ComReadMoreSection";
import BreadCrumb from "../../../Components/BreadCrumb/BreadCrumb";
const ArticleWriting = () => {
  const subCategoryId = "655659b9b9cbef8acade1d7c";
  const categoryId = "65524e633c005ef3b51907c9";
  const [isModelOpen, setIsModelOpen] = useState(false);
  const toggle = () => setIsModelOpen(!isModelOpen);
  const breadCrumbData = [
    { label: "Home", path: "/" },
    { label: "Homework Help" },
    { label: "Do My Thesis/Dissertation" },
  ];
  return (
    <>
      <Page subCategoryId={subCategoryId} categoryId={categoryId} />

      <div className="container">
        <div className="row mt-2 mb-2 m-0">
          <BreadCrumb items={breadCrumbData} />
        </div>
      </div>
      <MainBanner id={subCategoryId} setIsModelOpen={setIsModelOpen} />
      <AskSection
        onSignUp={() => {
          setIsModelOpen(true);
        }}
      />
      <BenefitsSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
        title="Benefits of DoubtQ Thesis/Dissertation Services"
        description="Designed to deliver quality, accuracy, and convenience for every student"
      />
      <AssignmentList
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
        title="Recently Completed Thesis or Dissertation Samples"
        description="Explore high-quality Thesis or Dissertation samples completed by experts for students"
      />
      <HelpSteps
        subCategoryId={subCategoryId}
        description="Get your Thesis or Dissertation support in 4 easy steps"
      />
      <Milestonerewards categoryId={categoryId} />
      <BonusSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
      />
      <Universities categoryId={categoryId} setIsModelOpen={setIsModelOpen} />
      <StudentStories />
      <ChatHelpExperts
        title="Meet our Thesis or Dissertation Experts"
        description="Our professionals deliver high-quality Thesis or Dissertation with an improved writing "
      />
      <ComWorldWide id={subCategoryId} />
      <ComReadMoreSection id={subCategoryId} />
      {isModelOpen && (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={{
            serviceType: "AssignmentHelp",
            type: "assignmentHelp",
            totalSteps: 1,
          }}
          subCategory={subCategoryId}
        />
      )}
      <ScrollTop />
    </>
  );
};

export default ArticleWriting;
